interface IGetSobQField {
  field: 'Actual' | 'Plan' | 'ExpExit'
  quarter: number
}

export const getSobQField = ({ field, quarter }: IGetSobQField) => {
  return `Sob${field}Q${quarter}`
}
